<form class="app-modal-form" [formGroup]="form" (ngSubmit)="submitForm()">
  <div class="form-group">
    <label>Цель обращения</label>
    <p-select class="traffic-select" [options]="supportTypes" optionLabel="label" optionValue="value" formControlName="type" placeholder="Выберите цель обращения" [autofocus]="false" [ngClass]="{
    'p-invalid': form.get('type')?.invalid && (form.get('type')?.touched)
  }"></p-select>
  </div>

  <div class="form-group">
    <label>Ваше имя</label>
    <input type="text" formControlName="name" placeholder="Иван" />
  </div>

  <div class="form-group">
    <label>Контактный телефон</label>
    <input type="text" formControlName="phone" placeholder="+7 000 000 00 00" />
  </div>

  <div class="form-group">
    <label>E-mail</label>
    <input type="text" formControlName="email" placeholder="mail@example.ru" />
  </div>

  <div class="form-group">
    <label>Сообщение</label>
    <textarea
      formControlName="message"
      rows="5"
      placeholder="Здравствуйте! У меня возник следующий вопрос."
    ></textarea>
  </div>

  <div class="app-modal-form__actions app-modal-form__actions--right">
    <svg-icon
      name="spinner"
      class="app-modal-form__spinner icon-spinner"
      *ngIf="formPending"
    ></svg-icon>

    <button
      class="app-modal-form__button app-modal-form__button--primary"
      type="submit"
      [attr.disabled]="formPending ? true : null"
    >
      Отправить
    </button>
  </div>
</form>
